var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "t-xmlcontainer"
  }, [_vm.loaded ? _c('div', {
    staticClass: "t-xmlcontent",
    domProps: {
      "innerHTML": _vm._s(_vm.xmlText)
    },
    on: {
      "!click": function click($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        return _vm.handleClick($event);
      }
    }
  }) : _c('div', {
    staticClass: "t-xmlplaceholder"
  }, [_c('div', [_vm._v(" Page " + _vm._s(_vm.logicalPages[_vm.pageNum - 1]) + " " + _vm._s(_vm.loading ? '(loading)' : _vm.denied ? '(denied)' : '') + " ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }